import { render, staticRenderFns } from "./TabHeader.vue?vue&type=template&id=be443374"
import script from "./TabHeader.vue?vue&type=script&lang=js"
export * from "./TabHeader.vue?vue&type=script&lang=js"
import style0 from "./TabHeader.vue?vue&type=style&index=0&id=be443374&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports